import React, { useRef, useCallback, FC } from 'react';
import styles from './styles.css';

export interface IMarqueeProps {
  text: string | undefined;
  scrollOffset?: number;
}

export const Marquee: FC<IMarqueeProps> = ({ text, scrollOffset = 0 }) => {
  const containerRef = useRef<HTMLDivElement>(null);

  const handleMouseOver = useCallback((e: React.MouseEvent<HTMLDivElement>) => {
    if (!containerRef.current) {
      return;
    }

    const target = (e.target as HTMLSpanElement) || ({ offsetWidth: 0 } as HTMLSpanElement);
    const containerWith = containerRef.current.offsetWidth;
    const childWith = target.offsetWidth;

    const diff = childWith - containerWith;

    if (diff > 0) {
      target.style.transition = `transform ${diff / 100}s linear`;
      target.style.transform = `translate(-${diff}px, 0)`;
    }
  }, []);

  const handleMouseLeave = useCallback((e: React.MouseEvent<HTMLDivElement>) => {
    const target = e.target as HTMLSpanElement;

    if (target) {
      target.style.transform = '';
      target.style.transition = '';
    }
  }, []);

  if (!text) {
    return null;
  }

  return (
    <div className={styles['container']}>
      <div
        ref={containerRef}
        className={styles['marquee']}
        onMouseOver={handleMouseOver}
        onMouseLeave={handleMouseLeave}
      >
        <span style={{ paddingRight: scrollOffset }} className={styles['text']}>
          {text}
        </span>
      </div>
    </div>
  );
};
